{
    "TODAY": "Today",
    "WEEKLY_FORECAST": "Weekly forecast",
    "TITLE": "Weather",
    "TITLE_WITH_LOCATION": "Weather forecast for {{location}}",
    "MIN_TEMPERATURE": "L: {{temp}}°",
    "MAX_TEMPERATURE": "H: {{temp}}°",
    "SUNSHINE_DURATION_HOURS": "{{duration}} h",
    "SUNSHINE_DURATION_LABEL": "hours of sunshine",
    "NO_DATA_INFO": "No weather forecast available.",
    "WEATHER_CODE_0": "Sunny",
    "WEATHER_CODE_1": "Mainly clear",
    "WEATHER_CODE_2": "Partly cloudy",
    "WEATHER_CODE_3": "Overcast",
    "WEATHER_CODE_45": "Fog",
    "WEATHER_CODE_48": "Depositing rime fog",
    "WEATHER_CODE_51": "Light drizzle",
    "WEATHER_CODE_53": "Moderate drizzle",
    "WEATHER_CODE_55": "Dense drizzle",
    "WEATHER_CODE_56": "Slight freezing drizzle",
    "WEATHER_CODE_57": "Dense freezing drizzle",
    "WEATHER_CODE_61": "Slight rain",
    "WEATHER_CODE_63": "Moderate rain",
    "WEATHER_CODE_65": "Heavy rain",
    "WEATHER_CODE_66": "Light freezing rain",
    "WEATHER_CODE_67": "Heavy freezing rain",
    "WEATHER_CODE_71": "Slight snow fall",
    "WEATHER_CODE_73": "Moderate snow fall",
    "WEATHER_CODE_75": "Heavy snow fall",
    "WEATHER_CODE_77": "Snow grains",
    "WEATHER_CODE_80": "Slight rain showers",
    "WEATHER_CODE_81": "Moderate rain showers",
    "WEATHER_CODE_82": "Heavy rain showers",
    "WEATHER_CODE_85": "Slight snow showers",
    "WEATHER_CODE_86": "Heavy snow showers",
    "WEATHER_CODE_95": "Thunderstorm",
    "WEATHER_CODE_96": "Thunderstorm with slight hail",
    "WEATHER_CODE_99": "Thunderstorm with heavy hail",
    "WEATHER_CODE_0_NIGHT": "Clear sky",
    "WEATHER_CODE_1_NIGHT": "Mainly clear",
    "WEATHER_CODE_2_NIGHT": "Partly cloudy",
    "WEATHER_CODE_UNKNOWN": "Unknown"
}